import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Avatar from "../../../../parts/avatar";
import DropdownOptions from "../../../../parts/dropdownOptions";
import SvgIcon from "../../../../parts/SvgIcon";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { isPullActiveCoach } from "../../../../utils/user-helpers";

const GymMemberRow = ({ member }) => {
  const { t } = useTranslation("coaching-portal");
  const [menuOpen, setMenuOpen] = useState(false);
  const { locals } = useRillContext();
  const { activeUserToRequest } = locals;
  const isActivePullCoach = isPullActiveCoach(activeUserToRequest);

  const dropdownOptions = useMemo(
    () => [
      { label: t("gymMembers.convertToPullLabel"), value: "convert-to-pull" },
    ],
    [t]
  );

  const handleRemove = () => {
    if (!confirm(t("gymMembers.removeConfirm"))) {
      return;
    }
    submit("/coaching-portal/gym-members/remove", {
      method: "POST",
      body: { clientId: member._id },
    });
  };

  const handleDropdownSelect = (value) => {
    if (value === "convert-to-pull") {
      if (!confirm(t("gymMembers.convertToPullConfirm"))) {
        return;
      }
      submit("/coaching-portal/gym-members/convert-to-pull", {
        method: "POST",
        body: { clientId: member._id },
      });
    }
  };

  return (
    <tr>
      <td>
        <div className="flex items-center gap-2">
          <div className="image-wrapper">
            {member.avatar ? (
              <Avatar size="32" url={getAvatarUrl(member)} user={{}} />
            ) : (
              <Avatar size="32" user={{ name: member.name }} />
            )}
          </div>
          <span className="subscriber-text">{member.name}</span>
        </div>
      </td>
      <td className="email">
        <a href={`mailto:${member.email}`}>{member.email}</a>
      </td>
      <td>{member.externalId || "-"}</td>
      <td>{member._id}</td>
      <td>
        <div className="action-cell flex gap-2 items-center justify-center">
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={handleRemove}
            type="button"
          >
            {t("gymMembers.remove")}
          </button>
          {isActivePullCoach && (
            <div className="menu-wrapper relative">
              <button
                data-button-type="secondary"
                data-icon-only
                onClick={() => setMenuOpen(!menuOpen)}
                type="button"
              >
                <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
              </button>
              <DropdownOptions
                options={dropdownOptions}
                onSelectFn={handleDropdownSelect}
                opened={menuOpen}
                initialDropwdownState={false}
                setDropdownState={setMenuOpen}
              />
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default GymMemberRow;
